import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { SharedModule } from '@edtech-ui/shared/shared.module';
import { TeacherSidenavbarComponent } from '@edtech-ui/dashboard/teacher/teacher-navbar/teacher-sidenavbar/teacher-sidenavbar.component';
import { filter } from 'rxjs';
import { TopNavbarComponent } from '@edtech-ui/student-dashboard-v2/top-navbar/top-navbar.component';
import { MatSidenav } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
	selector: 'app-student-dashboard',
	standalone: true,
	imports: [TeacherSidenavbarComponent, SharedModule, RouterModule, RouterOutlet, TopNavbarComponent],
	templateUrl: './student-dashboard.component.html',
	styleUrl: './student-dashboard.component.scss'
})

export class StudentDashboardComponent implements OnInit {

	collapsed: boolean = false;
	hideLayout = false;
	isMobile: boolean = false;
	@ViewChild(MatSidenav) sidenav!: MatSidenav;

	constructor(
		private router: Router,
		private observer: BreakpointObserver
	) {

		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: any) => {
				this.hideLayout = this.router.url.includes('/interview');
			});
	}

	ngOnInit() {
		this.observer.observe(['(max-width: 1024px)']).subscribe((screen) => {
			if (screen.matches) {
				this.isMobile = true;
				this.collapsed = false;
			} else {
				this.isMobile = false;
				this.collapsed = false;
			}
		});
	}

	toggleSidenav() {
		if (this.isMobile) {
			this.sidenav.toggle();
		} else {
			this.collapsed = !this.collapsed;
		}
	}

	closeSidenav() {
		if (this.isMobile) {
			this.sidenav.close();
		}
	}

}